import { createSelector } from 'reselect';

import getAllDocuments from '../layers/getAllDocuments';
import { PERSPECTIVE_TRANSFORM, RECTANGLE_TRANSFORM, SMOOTH_TRANSFORM } from 'src/models/transforms';

const ALLOWED_TRANSFORM_TYPES = new Set([RECTANGLE_TRANSFORM, PERSPECTIVE_TRANSFORM, SMOOTH_TRANSFORM]);

const getAllFinishTransforms = createSelector([getAllDocuments], (documents) =>
    documents.flatMap((doc) => {
        if (!doc.finishes?.length) return [];

        const eligibleTransforms = doc.transforms.filter(({ type }) => ALLOWED_TRANSFORM_TYPES.has(type));

        return doc.finishes.flatMap((finish) => {
            const id = `${doc.id} ${finish.name} Transform`;
            const bump = finish.scene.bumpScale;

            return eligibleTransforms.map((xform) => ({
                ...xform,
                id,
                points: xform.points.map((point) => ({
                    ...point,
                    x: point.x + bump,
                    y: point.y + bump,
                })),
            }));
        });
    }),
);

export default getAllFinishTransforms;
